import { useContext } from 'react';

import { TaskDetailContext } from './task-detail-context';

export const useOpenTaskDetail = () => {
  const { openTaskDetail } = useContext(TaskDetailContext);

  return openTaskDetail;
};
